export const ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_LIST = 'ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_LIST';




// WEBPACK FOOTER //
// ./src/store/Admin/modules/teacherInformationSheet/types.js